import { ReplaySubject } from 'rxjs';

import { ContentChild, Directive } from '@angular/core';
import { FormControlName } from '@angular/forms';

@Directive({
	selector: 'vquip-form-field',
})
export class FormFieldDirective {
	@ContentChild(FormControlName)
	set formControl(formControl: FormControlName) {
		this._formControl$.next(formControl);
	}
	get formControl$() {
		return this._formControl$.asObservable();
	}
	private _formControl$ = new ReplaySubject<FormControlName>(1);
}
